import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    timeSpent: {
      fontSize: theme.typography.pxToRem(10),
    },
  }),
);
